// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "footer[data-v-bef7684a]{background:#165fd8}.socials[data-v-bef7684a]{padding-left:25%;padding-right:25%;padding-bottom:12rem}", ""]);
// Exports
module.exports = exports;
